import { createActions, handleActions } from 'redux-actions';

export const {
    getFeatureFlagsData,
    getFeatureFlagsDataRequest,
    getFeatureFlagsDataSuccess,
    getFeatureFlagsDataFail,
} = createActions(
    'GET_FEATURE_FLAGS_DATA',
    'GET_FEATURE_FLAGS_DATA_REQUEST',
    'GET_FEATURE_FLAGS_DATA_SUCCESS',
    'GET_FEATURE_FLAGS_DATA_FAIL',
);

export const INITIAL_STATE = { loading: true, featureFlags: {} };

export default handleActions(
    {
        [getFeatureFlagsDataRequest.toString()]: (state) => ({ ...state, loading: true }),
        [getFeatureFlagsDataSuccess.toString()]: (state, { payload }) => ({
            ...state, loading: false, featureFlags: payload,
        }),
        [getFeatureFlagsDataFail.toString()]: (state) => ({
            ...state, loading: false, featureFlags: {},
        }),
    },
    INITIAL_STATE
);